export default "__VITE_ASSET__dlxJqxKmjmgf0BwBxD_HNA__"